export function resetOffset(_event: Event) {
  for (const id of ["pair_offset", "pair_y_offset"]) {
    const slider = document.getElementById(id) as HTMLInputElement | null;
    if (slider) slider.value = "0";
    const num = document.getElementById(`${id}_num`) as HTMLInputElement | null;
    if (num) num.value = "0";
  }
}
window.resetOffset = resetOffset;
